<template>
	<div>
		<div class="pg-breadcrumb">
			<div class="breadcrumb-item em">兑换商家绑定</div>
			<div class="breadcrumb-item">兑换商家绑定</div>
		</div>
		<!--		<div class="card-block">
					<Form inline class="pg-form-inline">
						<FormItem>
							<Input style="width: 150px;" clearable v-model="name"
										 @keyup.enter.native="handleSearch()" placeholder="商家名称"></Input>
						</FormItem>
						<FormItem>
							<div class="pg-btn-wrap">
								<div class="pg-btn style1" @click="handleSearch">搜索</div>
							</div>
						</FormItem>
					</Form>
				</div>-->
		<div class="table-box">
			<div class="pg-btn-wrap add">
				<div class="pg-btn style2" @click="handleShowModal('add')">添加商家</div>
			</div>
			<Table row-key="id" ref="selection" :columns="table.columns" :data="table.data" border>
				<template slot-scope="{ row, index }" slot="users">
					<span v-if="row.parther_user">{{ row.parther_user.user_name }}</span>
				</template>
				<template slot-scope="{ row, index }" slot="phone">
					<span v-if="row.parther_user">{{ row.parther_user.phone }}</span>
				</template>
				<template slot-scope="{ row, index }" slot="status">
					<span v-if="row.parther_user">{{ row.parther_user.status == 0 ? '正常': '冻结' }}</span>
				</template>
				<template slot-scope="{ row, index }" slot="userlog">
					<span v-if="row.user">{{ row.user.realname }}</span>
				</template>
				<template slot-scope="{ row, index }" slot="action">
					<div class="pg-btn-wrap">
						<div class="pg-btn style2" @click="handleShowModal('edit',row)">修改</div>
						<div class="pg-btn style1" @click="handleDEL(row)">刪除</div>
					</div>
				</template>
			</Table>
		</div>


		<Modal v-model="isShowModa"
					 title="新增/修改"
					 width="400"
					 :footer-hide="true"
					 @on-cancel="handleModalClose">
			<div class="modal-cont">
				<Form>
					<FormItem>
						<label class="input-label">商家账号：</label>
						<Select size="large" placeholder="请选择" clearable v-model="form.partner_id">
							<Option :value="item.user_id" v-for="(item, index) in orderTypes" :key="item.user_id">
								{{ item.user_name }}
							</Option>
						</Select>
					</FormItem>
					<FormItem>
						<label class="input-label"> * 商家名称：</label>
						<Input size="large" type="text" v-model="form.seller_name" placeholder="請輸入"></Input>
					</FormItem>
<!--					<FormItem>
						<DatePicker class="no-suffix" type="datetime" size="small" clearable
												placeholder="开始时间" value-format="yyyy-MM-dd hh:mm:ss"
												v-model="form.start_date"></DatePicker>
					</FormItem>
					<FormItem>
						<DatePicker class="no-suffix" type="datetime" size="small" clearable
												placeholder="结束时间" value-format="yyyy-MM-dd hh:mm:ss"
												v-model="form.end_date"></DatePicker>
					</FormItem>-->
					<FormItem>
						<div class="pg-btn-wrap">
							<div class="pg-btn style1" @click="handleConfirm">确定</div>
						</div>
					</FormItem>
				</Form>
			</div>
		</Modal>
	</div>
</template>

<script>
export default {
	name: "commodityTypes",
	data() {
		return {
			name: '', // 搜索
			form: {
				id: '',
				partner_id: '0',
				seller_name: '',
				// start_date: '',
				// end_date: ''
			},
			table: {
				columns: [
					{
						title: '商家名称',
						key: 'seller_name',
						tree: true
					}, {
						title: '账号名称',
						action: true,
						slot: 'users'
					},{
						title: '绑定账号',
						action: true,
						slot: 'phone'
					},{
						title: '账号状态',
						action: true,
						slot: 'status'
					},{
						title: '操作员',
						action: true,
						slot: 'userlog'
					},
					{
						title: '操作',
						action: true,
						slot: 'action'
					}
				],
				data: [],
			},

			orderTypes: [],
			isShowModa: false,
			modalType: ''
		}
	},
	created() {
		this.getList();
		this.getTyleslist();
	},
	methods: {
		// 获取列表
		getList() {
			this.$Rq.requestAuth({
				url: this.$Api.salesList,
				method: 'get'
			}).then((res) => {
				console.log(res)
				if (res.list.length) {
					this.table.data = res.list
				} else {
					this.table.data = []
				}
			})
		},
		// 刪除
		handleDEL(row) {
			this.$Modal.confirm({
				title: '提示',
				content: '是否删除',
				onOk: () => {
					this.$Rq.requestAuth({
						url: this.$Api.salesadd + `/${row.id}`,
						method: 'delete'
					}).then((res) => {
						this.$message.success('操作成功')
						this.getList();
					}).catch(err => {
						this.$message.error('操作失败')
					})
				},
				onCancel: () => {
				}
			});
		},
		// 关闭弹框
		handleModalClose() {
			this.form = {
				id: '',
				partner_id: '0', // 上级分贝
				seller_name: '', // 分类名称
			}
		},
		// 确定 新增  修改
		handleConfirm() {
			let url = this.$Api.salesadd, data = {...this.form},method = 'post';
			data.start_date = 0
			data.end_date = 0

			if (this.modalType == 'add') {
				delete data.id
			}else {
				url += `/${data.id}`
				method = 'put'
			}

			this.$Rq.requestAuth({
				url,
				method,
				data
			}).then((res) => {
				this.$message.success('操作成功')
				this.getList();
				this.handleModalClose();
				this.isShowModa = false
			}).catch(err => {
				this.$message.error('操作失败')
			})

		},
		// 弹出modal  添加分类
		handleShowModal(type, row) {
			this.modalType = type
			if (type == 'edit') {
				this.form.id = row.id
				this.form.partner_id = row.partner_id
				this.form.seller_name = row.seller_name
			}
			this.isShowModa = true
		},
		// 分裂列表
		getTyleslist() {
			this.$Rq.requestAuth({
				url: this.$Api.usertype4,
				method: 'get'
			}).then((res) => {
				if (res.list.length) {
					this.orderTypes = res.list;
				} else {
					this.orderTypes = []
				}
			})
		}


	}
}
</script>

<style scoped lang="scss">
.card-block {
	background-color: #FFFFFF;
	border-radius: 4px;
	padding: 15px;
}

.table-box {
	background-color: #FFFFFF;
	padding: 10px;
}

.add {
	padding: 20px 0;
}

.pg-btn-wrap {
	display: flex;
	align-items: center;

	.pg-btn {
		display: inline-block;
		vertical-align: middle;
		width: 120px;
		height: 35px;
		line-height: 35px;
		background: #fff;
		text-align: center;
		font-size: 14px;
		color: #999999;
		cursor: pointer;
		margin-right: 20px;
		text-decoration: none;
		border-radius: 3px;
		box-shadow: 0 2px 4px rgba(153, 153, 153, 0.5);
		-webkit-user-select: none;
		-moz-user-select: none;
		-ms-user-select: none;
		user-select: none;

		&:last-of-type {
			margin-right: 0;
		}

		&.style1 {
			color: #fff;
			background: rgba(255, 101, 101, 1);
			box-shadow: 0 2px 4px rgba(255, 101, 101, 0.5);
		}

		&.style2 {
			color: #fff;
			background: rgba(101, 132, 255, 1);
			box-shadow: 0 2px 4px rgba(101, 132, 255, 0.5);
		}

		&.style3 {
			color: #fff;
			background: #FF9A65;
			box-shadow: 0 2px 4px rgba(255, 154, 101, 0.5);
		}
	}

	.loading-btn {
		height: 35px;
		cursor: not-allowed;
		opacity: 0.9;
	}
}
</style>
